module.exports = __webpack_public_path__ + "eaf03c01b72692909878dc596f483b7e.png";